import {ThemeProvider, Hero} from '@primer/react-brand'
import {PlayIcon} from '@primer/octicons-react'
import {Spacer} from './components/Spacer'

const extURLs = {
  try: 'https://github.com/search?type=code&auto_enroll=true',
  video: 'https://www.youtube.com/watch?v=ujVY8xqkflQ',
}

export function CodeSearchIndex() {
  return (
    <ThemeProvider colorMode="dark" className="fp-hasFontSmoothing">
      {/* Header + Subnav = 136px */}
      <Spacer size="136px" />
      <Spacer size="48px" size1012="96px" />

      {/* Section Hero */}

      <section id="hero">
        <div className="fp-Section-container">
          <Hero data-hpc className="fp-Hero">
            <Hero.Label>Code Search</Hero.Label>
            <Hero.Heading size="2">Exactly what you’re looking for</Hero.Heading>
            <Hero.Description size="300">
              With GitHub code search, your code—and the world’s—is at your fingertips.
            </Hero.Description>
            <Hero.PrimaryAction href={extURLs.try}>Try it now</Hero.PrimaryAction>
            <Hero.SecondaryAction href={extURLs.video} trailingVisual={<PlayIcon />}>
              Watch video
            </Hero.SecondaryAction>
            <Hero.Image src="/images/modules/site/code-search/fp24/hero.webp" alt="TODO" />
          </Hero>
        </div>
      </section>

      <Spacer size="64px" size1012="128px" />
    </ThemeProvider>
  )
}

try{ CodeSearchIndex.displayName ||= 'CodeSearchIndex' } catch {}